import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Button, Card, Text, Paragraph } from "@zillow/constellation-10";
import { useState } from "react";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import LegalPopover from "../CalculatorForm/LegalPopover.esm.js";
import SelectField from "../Fields/SelectField.esm.js";
import TextField from "../Fields/TextField.esm.js";
import { calculatorDisclaimerText, FieldConfig } from "./LoanComparison.utils.esm.js";
import LoanComparisonResultForm from "./LoanComparisonResultForm.esm.js";
const LoanComparisonCardContent = (props) => {
  return /* @__PURE__ */ jsxs(Card, { elevated: false, tone: "neutral", css: {
    flex: 1
  }, children: [
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", css: {
      textAlign: "center",
      paddingBottom: "loose"
    }, asChild: true, children: /* @__PURE__ */ jsx("p", { children: props.headingText }) }),
    /* @__PURE__ */ jsx(TextField, { label: "Loan amount", name: FieldConfig[props.loanType + "LoanAmount"].name, leftAdornment: "$", config: FieldConfig[props.loanType + "LoanAmount"].config, autoComplete: "off", required: true, format: commaSeparateNumber }),
    /* @__PURE__ */ jsx(SelectField, { options: FieldConfig[props.loanType + "LoanTerm"].options, label: "Loan term (years)", name: FieldConfig[props.loanType + "LoanTerm"].name, required: true, config: FieldConfig[props.loanType + "LoanTerm"].config }),
    /* @__PURE__ */ jsx(TextField, { label: "Interest rate", rightAdornment: "%", name: FieldConfig[props.loanType + "InterestRate"].name, config: FieldConfig[props.loanType + "InterestRate"].config, required: true, autoComplete: "off", tooltip: {
      title: "Interest rate",
      body: /* @__PURE__ */ jsx(Paragraph, { children: "A percentage of your loan amount, like 6.25% of $400,000, that is variable based on factors you can influence and others that are market dependent." })
    } }),
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      alignItems: "flex-end"
    }, children: [
      /* @__PURE__ */ jsx(Box, { css: {
        marginRight: "tighter",
        flex: 1
      }, children: /* @__PURE__ */ jsx(SelectField, { options: FieldConfig[props.loanType + "LoanStartMonth"].options, label: "Loan start date", required: true, name: FieldConfig[props.loanType + "LoanStartMonth"].name, config: FieldConfig[props.loanType + "LoanStartMonth"].config }) }),
      /* @__PURE__ */ jsx(Box, { css: {
        flex: 1
      }, children: /* @__PURE__ */ jsx(SelectField, { options: FieldConfig[props.loanType + "LoanStartYear"].options, label: "", name: FieldConfig[props.loanType + "LoanStartYear"].name, config: FieldConfig[props.loanType + "LoanStartYear"].config }) })
    ] })
  ] });
};
function LoanComparisonFields() {
  const [activeForm, setActiveForm] = useState(true);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { css: {
      alignSelf: "flex-end"
    }, children: /* @__PURE__ */ jsx(LegalPopover, { triggerText: "Calculator disclaimer", text: calculatorDisclaimerText }) }),
    /* @__PURE__ */ jsx(Box, { css: {
      display: "flex",
      flexDirection: "column",
      gap: "loose",
      // Panda `lg` is 768px; SkunkWorks `lg` is 769px — use `xl` (1024px) for row to fix iPad 768 column parity.
      xl: {
        flexDirection: "row"
      }
    }, children: activeForm ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(LoanComparisonCardContent, { loanType: "typeOne", headingText: "Loan 1" }),
      /* @__PURE__ */ jsx(LoanComparisonCardContent, { loanType: "typeTwo", headingText: "Loan 2" }),
      /* @__PURE__ */ jsx(LoanComparisonCardContent, { loanType: "typeThree", headingText: "Loan 3" })
    ] }) : /* @__PURE__ */ jsx(LoanComparisonResultForm, {}) }),
    /* @__PURE__ */ jsx(Button, { tone: "brand", emphasis: "filled", type: "button", onClick: () => {
      setActiveForm(!activeForm);
    }, css: {
      alignSelf: "center",
      marginTop: "loose"
    }, children: activeForm ? "View comparison" : "New comparison" })
  ] });
}
export {
  LoanComparisonCardContent,
  LoanComparisonFields as default
};
